<template>
  <div class="transaction-section">
    <v-row
      v-if="!transactions || transactions.length <= 0"
      class="justify-center text-center mt-8"
      no-gutters
    >
      <v-col lg="4" md="12" sm="12" cols="12">
        <v-icon class="highlg--text opacity-50">mdi-shopping</v-icon>
        <div class="lgg--text">Subscribe to paid plan</div>
        <div class="md--text mt-4">
          Subscribing to plan, you'll be able to scrape at scale for the better
          price per API call.
        </div>
        <div class="mt-6">
          <v-btn color="primary" class="fontlight--text" @click="onSubscribeClick"
            >Subscribe to plan</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <v-row v-else no-gutters>
      <v-col lg="12" md="12" sm="12" cols="12">
        <v-card class="ma-3">
          <v-card-title class="xlg--text fontweight400 pt-6"
            >Transactions</v-card-title
          >
          <v-card-text class="text--primary">
            <v-data-table
              :headers="headers"
              :items="transactions"
              :items-per-page="transactions.length"
              hide-default-footer
              disable-pagination
              class="elevation-1"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.name">
                    <td style="min-width: 120px">{{ item.payment_date }}</td>
                    <td style="min-width: 120px">{{ item.plan_name }}</td>
                    <td style="min-width: 120px">{{ item.payment_status }}</td>
                    <td style="min-width: 120px">
                      {{ item.amount }} {{ item.currency }}
                    </td>
                    <td style="min-width: 120px">
                      <a :href="item.receipt_url">
                        <v-icon>mdi-file-document</v-icon></a
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="loading-overlay" v-if="loading">
      <v-progress-circular
        :size="50"
        :width="2"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "Transactions",
  data() {
    return {
      headers: [
        {
          text: "Payment date",
          value: "payment_date",
        },
        { text: "Plan", value: "plan_name" },
        { text: "Payment status", value: "payment_status" },
        { text: "Amount", value: "amount" },
        { text: "Receipt", value: "receipt_url", sortable: false },
      ],
      loading: false,
      transactions: [],
    };
  },
  mounted() {
    this.getTransactionHistory();
  },
  methods: {
    getTransactionHistory() {
      this.loading = true;
      this.$store.dispatch("transactions/getTransactionHistory").then(
        (res) => {
          this.loading = false;
          this.transactions = res.data;
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
    },
    onSubscribeClick() {
      this.$router.push({
        name: "Subscriptions",
      });
    },
  },
};
</script>

<style scoped>
td a {
  color: transparent;
}
td a:hover {
  color: #e2782f;
}
</style>
